import type { 
  GameState, 
  SaveMeta, 
  PersistenceAdapter, 
  ImportResult,
  AtlasNode
} from '../persistence-contract.js'
import {
  deleteSave as backendDeleteSave,
  exportArtifact as backendExportArtifact,
  importArtifactByCode as backendImportArtifactByCode,
  listSaves as backendListSaves,
  loadSave as backendLoadSave,
  readRemoteMetaTimestamp as backendReadRemoteMetaTimestamp,
  writeSave as backendWriteSave,
} from '../backend-api.js'

export class SupabasePersistenceAdapter implements PersistenceAdapter {
  async saveGame(uid: string, saveId: string, state: GameState): Promise<void> {
    await backendWriteSave(uid, saveId, state)
  }

  async loadGame(uid: string, saveId: string): Promise<GameState | null> {
    return backendLoadSave(uid, saveId)
  }

  async deleteGame(uid: string, saveId: string): Promise<void> {
    await backendDeleteSave(uid, saveId)
  }

  async listSaves(uid: string): Promise<SaveMeta[]> {
    return backendListSaves(uid)
  }

  async readRemoteMetaTimestamp(uid: string, saveId: string): Promise<{ exists: boolean; timestamp: number }> {
    return backendReadRemoteMetaTimestamp(uid, saveId)
  }

  async importByCode(code: string): Promise<ImportResult> {
    return backendImportArtifactByCode(code)
  }

  async exportArtifact(code: string, payload: string, type: 'blueprint' | 'vessel' | 'starter' | 'scenario'): Promise<void> {
    await backendExportArtifact(code, payload, type)
  }
}
